import { TrainRouteStop } from "features/CenterContent/VehicleDetails/TrainDetails/useTrainRoute";
import { Semantics } from "shared/components/drops/DropsBadge";
import { ThemeSemantic } from "shared/theme/themeSemantic";
import { delayThreshold } from "shared/utils/delayUtils";
import { Nullish } from "shared/utils/objectUtils";

export const getTrainLineColor = ({
  isVisited,
  isCancelled,
  theme,
}: {
  isNoPassing?: boolean;
  isVisited: boolean;
  isCancelled: boolean;
  theme: ThemeSemantic;
}) => {
  if (!isVisited) return theme.colorTextDisabled;
  if (isCancelled) return theme.colorOutlineMain;

  return theme.colorSemantic ?? theme.colorTextMain;
};

export const getTrainSemantic = ({
  delay,
  isVisited = true,
  isCancelled,
}: {
  delay: number;
  isVisited?: boolean;
  isCancelled?: boolean;
}): Semantics | undefined => {
  if (!isVisited) return undefined;
  if (isCancelled) return undefined;

  if (delay < -1) return "info";
  if (delay >= delayThreshold.major) return "alarm";
  if (delay >= delayThreshold.moderate) return "secondaryAlarm";
  if (delay >= delayThreshold.minor) return "warning";
  return "success";
};

export const isCancelled = (stop?: TrainRouteStop) =>
  stop?.cancelled === "CANCELLED";

/*
True if the stop is not cancelled and the train should have passed the stop(later stops have real time passing data),
but there are noe real time passing data for the stop.
* */
export const isStopWithNoPassing = (
  stopIndex: number,
  lastArrivedStopIndex: number,
  stop?: TrainRouteStop,
) =>
  !isCancelled(stop) &&
  !stop?.isArrived &&
  !stop?.actualDepartureTime &&
  stopIndex < lastArrivedStopIndex;

export const calculateMinuteDelay = (
  startDate: Nullish<Date>,
  endDate: Nullish<Date>,
) => {
  if (!startDate || !endDate) return undefined;
  const diffMs = new Date(endDate).getTime() - new Date(startDate).getTime();
  const diffMinutes = Math.round(diffMs / 60000);
  return diffMinutes;
};
